window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.password-wrapper').forEach((passwordWrapper) => {
        const eyeIcon = passwordWrapper.querySelector('.icon-eye');
        const eyeOff = passwordWrapper.querySelector('.icon-eye-off');
        const passwordField = passwordWrapper.querySelector('input');
        const passwordIcons = passwordWrapper.querySelector('.password-icons');

        passwordIcons?.addEventListener('click', () => {
            if (passwordField.type === 'password') {
                passwordField.type = 'text';
                eyeIcon.classList.add('hidden');
                eyeOff.classList.remove('hidden');
            } else {
                passwordField.type = 'password';
                eyeIcon.classList.remove('hidden');
                eyeOff.classList.add('hidden');
            }
        });

        // Prevent submitting the same "Demande de service" form multiple times from double-clicks
        document.querySelectorAll('form.service-form').forEach((form) => {
            form.addEventListener('submit', function handleSubmit(e) {
                const submittedClass = 'submitted';
                if (this.classList.contains(submittedClass)) {
                    e.preventDefault();
                } else {
                    this.classList.add(submittedClass);
                }
            });
        });
    });
});
